import { Styles } from 'react-jss';
import Variables, { getMaxWidthBreakPoint } from 'Variables.styles';

export const LoginStyles: Styles = {
  container: {
    padding: `${Variables.large} 0`,
    [getMaxWidthBreakPoint(Variables.breakpoints.sm)]: {
      // for better readability on mobile device
      padding: `0 ${Variables.large}`,
      margin: '0 auto',
    },
  },
  title: {
    fontSize: Variables.fontSize.h1,
    marginBottom: Variables.large,
  },
  textSm: {
    color: Variables.gray600,
    fontSize: Variables.fontSize.small,
    letterSpacing: '0.25px',
  },
  errorTitle: {
    fontSize: Variables.fontSize.giant,
    marginBottom: Variables.large,
    display: 'flex',
    justifyContent: 'center',
  },
  alternativeOtpMethods: {
    textAlign: 'center',
    '& button': {
      margin: `${Variables.medium} 0`,
    },
  },
  alternativeOtpMethodsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'space-between',
    width: '100%',
  },
  alternativeOtpInputContainer: {
    flexGrow: 1,
    marginRight: Variables.small,
  },
};

export const RegisterSuccessStyles: Styles<string, {isInvalid: boolean}> = {
  title: {
    fontSize: '24px',
    padding: '24px 0',
  },
  otpInput: {
    borderRadius: Variables.small,
    border: '1px solid transparent',
    boxShadow: ({ isInvalid }) => (isInvalid ? `0 0 0 2px ${Variables.redInvalidControl}` : `0 0 0 1px ${Variables.gray200}`),
    outline: 'none',
    fontSize: '1.6rem',
    lineHeight: '2.4rem',
    padding: '12px 16px',
    width: Variables.extraLarge,
    textAlign: 'center',
    WebkitAppearance: 'none',
    '&:not(:first-child)': {
      marginLeft: Variables.medium,
    },
    '&:focus': {
      boxShadow: `0 0 0 2px ${Variables.electricBerry}`,
    },
  },
  [getMaxWidthBreakPoint(Variables.breakpoints.sm)]: {
    otpInput: {
      width: '44px',
      fontSize: '1.6rem',
      padding: '10px',
      '&:not(:first-child)': {
        marginLeft: Variables.small,
      },
    },
  },
  [getMaxWidthBreakPoint(Variables.breakpoints.xs)]: {
    otpInput: {
      width: '40px',
      fontSize: '1.6rem',
      padding: '10px 6px',
      '&:not(:first-child)': {
        marginLeft: Variables.small,
      },
    },
  },
  buttonDisabled: {
    color: 'grey',
  },
  container: {
    [getMaxWidthBreakPoint(Variables.breakpoints.sm)]: {
      padding: Variables.large,
    },
  },
  link: {
    color: Variables.electricBerry,
    letterSpacing: '0.86px',
    fontWeight: '500',
  },
};

export const ForgotPasswordStyles: Styles = {
  title: {
    fontSize: Variables.fontSize.h1,
    margin: 0,
  },
  btn: {
    width: '100% !important',
    display: 'block !important',
  },
};
